export default "/images/8997a76eb6b9fa22613c790cb0701b20.avif";